import './js/header';
import './js/hero';
import './js/slick.min';
import './js/all_categories';
import './js/popular_recipes';
import './js/card_template';
import './js/search_filters';
import './js/all_recipes';

import './js/modals/mobile_menu';
import './js/modals/order_now';
import './js/modals/rating';
import './js/modals/recipe';
import './js/modals/scroll-up';

import './js/api';
